import { t } from "i18next";
import type { ApiError } from "../../../api";
import type { ShowToastFn } from "../../../mantine/notifications/useToast";
import { SaveMeterError } from "../MeterConfiguration/SaveMeterError/SaveMeterError";

export type DifferentParamsInfo = Array<Record<string, Array<string>>>;

interface SaveMeterErrorData {
  extraInfo?: {
    meterName: string;
    differingParameters: DifferentParamsInfo;
  };
  error?: string;
  detail?: string;
}

export function showSaveMeterErrorToast(
  showToast: ShowToastFn,
  error: ApiError<SaveMeterErrorData>
) {
  if (error?.response?.status === 500) {
    showToast({ type: "error", message: t("errors.ServerError") });
  } else {
    const errorMessage =
      error.response?.data.error || error.response?.data.detail;
    const errorExtraInfo =
      !!error.response?.data?.extraInfo?.differingParameters?.length;
    const meterName = error.response?.data?.extraInfo?.meterName;
    const meterDifferingParameters =
      error.response?.data?.extraInfo?.differingParameters;

    showToast({
      type: "error",
      message: (
        <SaveMeterError
          errorExtraInfo={errorExtraInfo}
          errorMessage={errorMessage}
          meterDifferingParameters={meterDifferingParameters}
          meterName={meterName}
        />
      ),
      autoClose: false,
      withCloseButton: true
    });
  }
}
